import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Menu, Button } from 'antd';
import {
    LoginOutlined,
    KeyOutlined,
    SyncOutlined,
    FormOutlined,
    HomeOutlined,
    UsergroupAddOutlined,
    BellOutlined,
    BarChartOutlined,
    DollarCircleOutlined,
    SecurityScanOutlined,
} from '@ant-design/icons';
import { Image } from 'antd';
import { logout } from '../../../api/auth';
import userIcon from '../../../assets/img/png/userIcon.png';


import './MenuLeftSider.scss';

function MenuLeftSider(props) {
    const { location, name, setCollapse, companyImage } = props;

    const logoutUser = () => {
        logout();
        window.location.reload();
    };

    return (
        <>
            <div className="menu-sider">
                <Image
                    className="menu-sider__image"
                    src={companyImage ? companyImage : userIcon}
                />

                <h1 className="margin-bottom-label">¡Bienvenido!</h1>

                <h1 className="margin-bottom-label">{name}</h1>
            </div>
            <Menu
                theme="dark"
                mode="inline"
                defaultSelectedKeys={[location.pathname]}
                onClick={() => setCollapse(true)}
            >
                <Menu.Item key="/manager" icon={<HomeOutlined />}>
                    <Link to={'/manager'}>Inicio</Link>
                </Menu.Item>
                <Menu.Item
                    key="/manager/users"
                    icon={<UsergroupAddOutlined />}
                >
                    <Link to={'/manager/users'}>Usuarios</Link>
                </Menu.Item>
                <Menu.Item
                    key="/manager/reports"
                    icon={<BarChartOutlined />}
                >
                    <Link to={'/manager/reports'}>Reportes</Link>
                </Menu.Item>
                <Menu.Item
                    key="/manager/accessCode"
                    icon={<SecurityScanOutlined />}
                >
                    <Link to={'/manager/accessCode'}>Códigos</Link>
                </Menu.Item>
                <Menu.Item
                    key="/manager/changePassword"
                    icon={<KeyOutlined />}
                >
                    <Link to={'/manager/changePassword'}>
                        Cambiar Contraseña
                    </Link>
                </Menu.Item>
                <Menu.Item
                    key="/manager/updates"
                    icon={<SyncOutlined />}
                >
                    <Link to={'/manager/updates'}>Actualizaciones</Link>
                </Menu.Item>
                <Menu.Item key="/manager/policy" icon={<FormOutlined />}>
                    <Link to={'/manager/policy'}>
                        Términos y Condiciones
                    </Link>
                </Menu.Item>
                <Menu.Item key="4" icon={<LoginOutlined />}>
                    <Button
                        type="text"
                        className="menu-side-btn"
                        onClick={logoutUser}
                    >
                        Cerrar Sesión
                    </Button>
                </Menu.Item>
            </Menu>
        </>
    );
}

export default withRouter(MenuLeftSider);
